import { render, staticRenderFns } from "./PsoriasisHypothesisPhase.vue?vue&type=template&id=46e8dcad&scoped=true&"
import script from "./PsoriasisHypothesisPhase.vue?vue&type=script&lang=js&"
export * from "./PsoriasisHypothesisPhase.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e8dcad",
  null
  
)

export default component.exports